import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import moment from 'moment-jalaali';
declare let $: any

@Component({
  selector: 'app-fleetdiag-driving-quality',
  templateUrl: './fleetdiag-driving-quality.component.html',
  styleUrls: ['./fleetdiag-driving-quality.component.css', '../../fleetdiag-dashboard-pro.component.scss']
})
export class FleetdiagDrivingQualityComponent implements OnInit {
  report: any = {};

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strUnitID: new FormControl(''),
    strSTime: new FormControl(''),
    strETime: new FormControl(''),
    iFleetDiag_SystemUser: new FormControl(''),
    source: new FormControl(''),
  });

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {

    try {
      const { id, slug } = this.route.snapshot.params;

      const isFleetUser = id.length < 15 && id.length > 3;
      const controlName = isFleetUser ? 'iFleetDiag_SystemUser' : 'strUnitID';

      if (id) {
        this.searchForm.patchValue({
          [controlName]: id,
          tiGroup: slug,
          source: isFleetUser ? 'users' : 'car-info'
        });

        this.openModal();
      }
    } catch (error) {
      this._tooltip.showError('IMEI شناسایی نشد');
    }
  }

  openModal() {
    setTimeout(() => {
      this.searchForm.patchValue({
        strSTime: `${moment().format('jYYYY/jMM/jDD')} 00:00:01`,
      })
      $("#dateTimeModal").modal("show");
    }, 100);
  }

  async fetchData() {

    this._otherService.Showspinner()

    const model = this._otherService.stringNumberToNumber(this.searchForm.value);

    const endpoint =
      this.searchForm.value.source === 'users'
        ? 'FleetDiag_AnalyzeDrivingQuality4FleetDiag'
        : 'FleetDiag_AnalyzeDrivingQuality4FleetYar';

    const response = JSON.parse(
      (await axios.post(endpoint, model)).data.toString()
    );

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'driving-quality' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    this.report = response?.Table;

    $("#dateTimeModal").modal("hide");

  }

  getValue(section: string, title: string): string {
    const item = this.report.find(x => x.Section === section && x.Title === title);
    return item ? item.Value : '-';
  }

  getNumericValue(section: string, title: string): number {
    const valStr = this.getValue(section, title);
    return parseFloat(valStr) || 0;
  }

  getScoreStatus(score: number): string {
    if (score >= 90) return 'عالی';
    if (score >= 80) return 'خوب';
    if (score >= 70) return 'قابل قبول';
    return 'نامناسب';
  }

  getScoreColorClass(score: number): string {
    if (score >= 90) return 'text-green';
    if (score >= 80) return 'text-blue';
    if (score >= 70) return 'text-orange';
    return 'text-red';
  }

  getScoreBgClass(score: number): string {
    if (score >= 90) return 'text-green-bg';
    if (score >= 80) return 'text-blue-bg';
    if (score >= 70) return 'text-orange-bg';
    return 'text-red-bg';
  }

  getEventColorClass(value: number): string {
    if (value <= 1) return 'text-green';
    if (value < 4) return 'text-blue';
    if (value < 7) return 'text-orange';
    return 'text-red';
  }

  getIdleTimeColorClass(value: number): string {
    if (value < 1) return 'text-green';
    if (value < 6) return 'text-blue';
    if (value < 11) return 'text-orange';
    return 'text-red';
  }

  getSuggestions(): any[] {
    return this.report.filter(x => x.Section === 'پیشنهاد');
  }

  getSuggestionIcon(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'info': return 'fa-info-circle';
      case 'warning': return 'fa-exclamation-triangle';
      case 'danger': return 'fa-times-circle';
      case 'success': return 'fa-check-circle';
      default: return 'fa-info-circle';
    }
  }

  getSuggestionColorClass(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'info': return 'text-blue';
      case 'warning': return 'text-orange';
      case 'danger': return 'text-red';
      case 'success': return 'text-green';
      default: return 'text-blue';
    }
  }

  getSuggestionBgClass(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'info': return 'text-blue-bg';
      case 'warning': return 'text-orange-bg';
      case 'danger': return 'text-red-bg';
      case 'success': return 'text-green-bg';
      default: return 'text-blue-bg';
    }
  }


}
